import { SubmissionError } from 'redux-form';
import { createPhoneCode, createToken } from './signinActions';

const submit = (values, dispatch, props) => {
  let phoneNumber;

  if (values.phoneNumber) {
    phoneNumber = `${values.callingCode}${values.phoneNumber
      .replace(/\s/g, '')
      .replace(/^0/, '')}`;
  }

  if (!values.phoneNumber) {
    throw new SubmissionError({
      phoneNumber: 'Champ requis'
    });
  }
  if (props.createPhoneCodeSuccess && !values.confirmationCode) {
    throw new SubmissionError({
      confirmationCode: 'Champ requis'
    });
  }
  if (values.phoneNumber && !values.confirmationCode) {
    dispatch(createPhoneCode(phoneNumber));
  }
  if (props.createPhoneCodeSuccess && values.confirmationCode) {
    dispatch(
      createToken({
        phoneNumber,
        confirmationCode: values.confirmationCode
      })
    );
  }
};

export default submit;
